import { render, staticRenderFns } from "./CashiersDashboard.vue?vue&type=template&id=38b97d40&scoped=true"
import script from "./CashiersDashboard.vue?vue&type=script&lang=js"
export * from "./CashiersDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b97d40",
  null
  
)

export default component.exports